import React, { useState, useEffect } from 'react';
import cn from "classnames";
import './toggle-button-group.scss';

const ToggleButtonGroup = ({
  options = [],
  value,
  onChange,
  name,
  disabled = false,
  required = false,
  id,
  resetKey,
}) => {
  const [showCustom, setShowCustom] = useState(false);
  
  // Reset showCustom when resetKey changes
  useEffect(() => {
    setShowCustom(false);
  }, [resetKey]);

  // Show Custom button if it's selected
  useEffect(() => {
    if (value === "Custom") {
      setShowCustom(true);
    }
  }, [value]);

  const handleClick = (option) => {
    if (disabled) return;
    
    // Create synthetic event to maintain compatibility with existing onChange handlers
    const syntheticEvent = {
      target: {
        type: 'button',
        name,
        value: option.value,
      },
    };
    
    onChange(syntheticEvent);
  };

  const setDisabled = (optionValue) => {
    if (disabled) return true;
    if (optionValue === "Custom" && value !== "Custom") return true;
    return false;
  };

  // Filter options based on showCustom state
  const visibleOptions = options.filter(option => {
    // If less than 3 options, show all
    if (options.length < 3) return true;
    // If Custom button and not shown yet, hide it
    if (option.value === "Custom" && !showCustom) return false;
    return true;
  });

  return (
    <div className={cn("toggle-button-group", {
      "tripple-column": name === "accountType",
    })} id={id}>
      {visibleOptions.map((option, index) => (
        <button
          key={`${option.value}-${index}`}
          type="button"
          className={cn("toggle-button", {
            active: value === option.value || visibleOptions.length === 1,
            disabled: setDisabled(option.value)
          })}
          onClick={() => handleClick(option)}
          disabled={setDisabled(option.value)}
          aria-pressed={value === option.value}
        >
          {option.text}
        </button>
      ))}
    </div>
  );
};

export default ToggleButtonGroup; 